import angular from 'angular';
import uiRouter from 'angular-ui-router';
import modalRejectRequestComponent from './modalRejectRequest.component';

let modalRejectRequestModule = angular.module('modalRejectRequest', [
  uiRouter
])

.component('modalRejectRequest', modalRejectRequestComponent)

.name;

export default modalRejectRequestModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestModal/modalRejectRequest/modalRejectRequest.js